import _ from 'lodash'
import maxAge from './maxAge'
import costOnYear from './costOnYear'

export default (form) => (
  _.map(_.range(0, maxAge(form)), (year) => ({
    year: year + 1,
    value: _.round(costOnYear(form, year)),
  }))
)
